import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { QuickKeyFolder } from '../../../quick-keys/qk-types'
import { QuickKeyNodeType } from '../../../quick-keys/qk.constants'

interface QKFolderProps {
  quickKey: QuickKeyFolder
  isFocussed?: boolean
  onClick: (node: QuickKeyFolder) => void
  setFocus: (node: QuickKeyFolder) => void
}

export const QKFolder: FunctionComponent<QKFolderProps> = ({
  quickKey,
  isFocussed,
  onClick,
  setFocus,
}) => {
  const [hover, setHover] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current && isFocussed) {
      containerRef.current.focus()
    }
  }, [isFocussed])

  return (
    <div
      onClick={() => onClick(quickKey)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onMouseDown={() => setFocus(quickKey)}
      ref={containerRef}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={isFocussed ? 0 : undefined}
      className={classNames(
        'vd-quick-key',
        `vd-quick-key--${quickKey.viewData.color}`,
        `vd-quick-key--${QuickKeyNodeType.FOLDER}`,
        { 'vd-quick-key--hover': hover }
      )}
    >
      <div
        className={classNames('vd-quick-key-inner')}
        data-product-id={quickKey.node.product_id}
      >
        <span className="vd-quick-key-folder-count">
          {quickKey.viewData.folderSize}
        </span>
        <span className="vd-quick-key-label">{quickKey.viewData.label}</span>
      </div>
    </div>
  )
}
